import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import { TbShieldLock } from "react-icons/tb";
import style from "../../style/Pages/PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  //   const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p>Account Summary</p>
        </div>
      </div>
      <div className={mainStyle.mainContentView} style={{ height: "92%" }}>
        <div className={mainStyle.mainContentViewsb}>
          <div className={style.privacyWrapper}>
            {/* <Link to="/" className={style.backLink}>
              <TbArrowLeft className={style.backIcon} /> Back to Help Center
            </Link> */}

            <div className={style.header}>
              <TbShieldLock className={style.headerIcon} />
              <h1>Privacy Policy</h1>
            </div>

            <div className={style.content}>
              <p className={style.updatedDate}>Last Updated: July 16, 2025</p>

              <section>
                <h2>1. Overview</h2>
                <p>
                  This Privacy Policy describes how we collect, use, disclose,
                  and protect your personal information when you use our
                  platform. By accessing or using our services, you agree to the
                  terms outlined here.
                </p>
              </section>

              <section>
                <h2>2. Information We Collect</h2>
                <ul>
                  <li>
                    <strong>Personal Information:</strong> Name, email address,
                    phone number, company details.
                  </li>
                  <li>
                    <strong>Account Credentials:</strong> Passwords (encrypted),
                    login history.
                  </li>
                  <li>
                    <strong>Usage Data:</strong> IP address, browser type,
                    device details, time spent, and pages visited.
                  </li>
                  <li>
                    <strong>Communication Content:</strong> Chat messages, media
                    files, reactions, and activity logs.
                  </li>
                  <li>
                    <strong>Cookies & Tracking:</strong> We use cookies for
                    analytics, authentication, and session management.
                  </li>
                </ul>
              </section>

              <section>
                <h2>3. How We Use Your Information</h2>
                <ul>
                  <li>To provide, operate, and maintain the platform.</li>
                  <li>
                    To improve performance, usability, and user experience.
                  </li>
                  <li>
                    To send service-related notifications and announcements.
                  </li>
                  <li>
                    To ensure security, detect fraud, and enforce policies.
                  </li>
                  <li>To respond to inquiries and provide support.</li>
                </ul>
              </section>

              <section>
                <h2>4. Data Sharing and Disclosure</h2>
                <p>
                  We do <strong>not sell</strong> your personal information. We
                  may share your data with:
                </p>
                <ul>
                  <li>
                    Service providers (e.g., hosting, analytics, customer
                    support).
                  </li>
                  <li>
                    Government or regulatory authorities when legally required.
                  </li>
                  <li>
                    In case of a merger, acquisition, or asset transfer, with
                    due notice.
                  </li>
                </ul>
              </section>

              <section>
                <h2>5. Data Retention</h2>
                <p>
                  We retain your personal data as long as your account is active
                  or as necessary to comply with our legal obligations and
                  resolve disputes.
                </p>
              </section>

              <section>
                <h2>6. Security Measures</h2>
                <p>
                  We implement technical and organizational safeguards to
                  protect your data including:
                </p>
                <ul>
                  <li>End-to-end encryption of messages.</li>
                  <li>Secure password storage and access control.</li>
                  <li>Regular system updates and security audits.</li>
                </ul>
              </section>

              <section>
                <h2>7. Your Rights</h2>
                <p>
                  You may exercise the following rights, subject to applicable
                  laws:
                </p>
                <ul>
                  <li>Access, update, or delete your personal data.</li>
                  <li>Withdraw consent for processing (where applicable).</li>
                  <li>Object to marketing communications.</li>
                  <li>Request data portability.</li>
                </ul>
              </section>

              <section>
                <h2>8. International Data Transfers</h2>
                <p>
                  If you are located outside India, your data may be transferred
                  to and processed in India or other countries. We ensure
                  appropriate safeguards are in place to protect your data.
                </p>
              </section>

              <section>
                <h2>9. Third-Party Links</h2>
                <p>
                  Our platform may contain links to third-party websites or
                  services. We are not responsible for their content or privacy
                  practices. Please review their privacy policies before
                  providing any information.
                </p>
              </section>

              <section>
                <h2>10. Changes to This Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy occasionally. The "Last
                  Updated" date reflects the latest changes. Continued use of
                  the platform implies your acceptance of the updated policy.
                </p>
              </section>

              <section>
                <h2>11. Contact Us</h2>
                <p>
                  If you have questions, concerns, or complaints regarding this
                  policy, please reach out to:
                </p>
                <p>
                  <strong>Email:</strong>{" "}
                  <a href="mailto:privacy@yourapp.com">privacy@yourapp.com</a>
                  <br />
                  <strong>Address:</strong> Sea Sense Software Solutions,
                  Marthandam, India
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default PrivacyPolicy;
